<div [hidden]="showEphemeral">
  <ng-content></ng-content>
</div>
<div [hidden]="!showEphemeral">
  <ng-content select=".wl-ephemeral-content"></ng-content>
</div>
